module.exports = __webpack_public_path__ + "static/media/v10.5474040b.mp4";